import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UpgradeBanner() {
  const navigate = useNavigate();

  return (
    <Box sx={{
      p: 3, borderRadius: "12px",
      background: "linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)",
      color: "#fff", textAlign: "center",
    }}>
      <Zap size={28} style={{ marginBottom: 8 }} />
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
        Unlock your full optimized resume
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.85, mb: 2 }}>
        Get 40 credits for ₹199 — download resume PDFs, generate cover letters, and view your history.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/pricing")}
        sx={{ bgcolor: "#fff", color: "#1e40af", fontWeight: 700, borderRadius: "8px", "&:hover": { bgcolor: "#f0f9ff" } }}
      >
        Get 40 Credits — ₹199 →
      </Button>
    </Box>
  );
}
